import { MathUtils } from 'three';

export const normaliseAngle = (angle: number) => {
    return MathUtils.euclideanModulo(angle, 360);
};

export const updateViewerPan = (viewer: Autodesk.Viewing.GuiViewer3D, values: { yaw: number; pitch: number }) => {
    const { yaw, pitch } = values;

    const nav = viewer.navigation;
    const position = nav.getPosition().clone();
    const currentTarget = nav.getTarget().clone();

    const radius = position.distanceTo(currentTarget);

    const yawRad = MathUtils.degToRad(yaw);
    const pitchRad = MathUtils.degToRad(pitch);

    // // Calculate current distance to maintain it
    // const distance = Math.sqrt(
    //     Math.pow(currentTarget.x - position.x, 2) +
    //         Math.pow(currentTarget.y - position.y, 2) +
    //         Math.pow(currentTarget.z - position.z, 2)
    // );

    // Calculate new target position
    // const horizontalDistance = Math.cos(pitchRad) * distance;

    // const newTarget = new THREE.Vector3(
    //     position.x + horizontalDistance * Math.cos(yawRad),
    //     position.y + horizontalDistance * Math.sin(yawRad),
    //     position.z + Math.sin(pitchRad) * distance
    // );

    const dir = new THREE.Vector3(
        Math.sin(yawRad) * Math.cos(pitchRad), // X
        Math.cos(yawRad) * Math.cos(pitchRad), // Y
        Math.sin(pitchRad) // Z
    )
        .normalize()
        .multiplyScalar(radius);

    const target = position.clone().add(dir);

    nav.setView(position, target);

    viewer.impl.sceneUpdated(true);
};

export const updateViewerFOV = (viewer: Autodesk.Viewing.GuiViewer3D, values: { fov: number }) => {
    const { fov } = values;

    const camera = viewer.getCamera() as THREE.PerspectiveCamera;

    camera.fov = fov;

    camera.updateProjectionMatrix();

    viewer.impl.sceneUpdated(true);
};
